import React, { useContext } from "react";
import { ThemeContext } from "../../contexts/ThemeContext";
const CoreInputStyles =
  "w-full text-base mt-1 mb-1  font-light  bg-no-repeat bg-[7px_center] p-3 border-solid border border-[#50565F] outline-none rounded-md focus:border-[#0B6BAC] disabled:opacity-50";
const DARK_THEME = "text-full-white bg-[#313945]";
const LIGHT_THEME = "";
const BasicInput = ({
  name,
  label,
  disabled,
  type,
  step,
  maxLength,
  minLength,
  onChange,
  placeholder,
  value,
  pattern,
  required,
  className,
  onInput,
  testId,
  defaultValue,
  autoFocus,
  onClick,
  readOnly = false,
  list = undefined,
}) => {
  const theme = useContext(ThemeContext).theme;
  const input = (
    <input
      name={name}
      className={`${CoreInputStyles} ${theme === "dark" ? DARK_THEME : LIGHT_THEME} ${className ?? ""} basic-input`}
      disabled={disabled}
      type={type || "text"}
      maxLength={maxLength}
      minLength={minLength}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      placeholder={placeholder}
      value={value}
      pattern={pattern}
      required={required ?? false}
      onInput={onInput}
      data-testid={testId}
      defaultValue={defaultValue}
      autoFocus={autoFocus === true}
      step={step ?? undefined}
      onClick={onClick ?? undefined}
      readOnly={readOnly}
      list={list}
    />
  );
  if (label) {
    return (
      <label className={`w-full text-sm text-full-white my-1 block`}>
        {label}
        {input}
      </label>
    );
  } else {
    return input;
  }
};

export default BasicInput;
export { CoreInputStyles, DARK_THEME, LIGHT_THEME };
